import React from 'react'
import AccordionLong from '../../pages/Home/FAQ/AccordionLong';
import "./FAQs.css"
import { Fade } from "react-reveal";
import Footer from '../../components/Footer/Footer';

const FAQs = () => {
  return (
    <><Fade duration={250}>
      <div className='faqs-container'>
      <div className='faqs-flex'>
        <div className='faq-left'>
          <div className='faq-header-text faqs-header'>Frequently asked questions</div>
          <div className='faq-subText faqs-sub'>
            Everything you need to know about the product and pricing. Can’t
            find an answer? Please{' '}
            <span className='reach-out'>
              <a href='#'>reach out to us</a>
            </span>
          </div>
        </div>
        <div className='faq-right'>
          <AccordionLong />
        </div>
      </div>
    </div>
    </Fade>
    <Footer/>
    </>
    
    
  )
}

export default FAQs